import { gql } from '@apollo/client'

export const Query = gql`
  query CustomFields(
    $companyId: ID!,
    $filters: CustomFieldFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    customFields(companyId: $companyId, filters: $filters, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        name
        resourceType
        fieldType
        enabled
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
